<template>
  <div>
     <h5 class="m-b-30">
       Question: {{ questionWithChoices.question }}
     </h5>
     <ul class="feedback-options">
       <li v-for="choice in questionWithChoices.Choice" v-bind:key="choice.id">
         <b-form-radio v-model="selected" name="feedback-selection" :value="choice.id">{{ choice.choice }}</b-form-radio> 
       </li>
     </ul>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        selected: null
      }
    },
    props: {
      questionWithChoices: {
        type: Object,
        default: () => ({})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .feedback-options{
     list-style-type: none;
     padding-left: 0;
     li{
       padding: 10px 15px;
       
     }
  }
</style>